import React, { PropsWithChildren, useState, JSX } from 'react';
import { useMount } from 'react-use';

const FadeIn = (props: PropsWithChildren<{}>): JSX.Element => {
  const { children } = props;
  const [isMounted, setIsMounted] = useState<boolean>(false);

  useMount(() => {
    setIsMounted(true);
  });

  return <div className={`fade-in${isMounted ? ' fade-in--transition' : ''}`}>{children}</div>;
};

export default FadeIn;
